(function($, undefined) {
	"use strict";

	let form;
	
	function init() {
		let loginForm = $("#login-form");
		let forgotForm = $("#forgot-form");

		form = Fw.component.models().form;
		
		$("#forgot-btn").on("click", showForgotForm);
		$("#forgot-cancel").on("click", showLoginForm);
		$(".login-last-news[data-url]").on("click", goToNews);
		forgotForm.on("submit", submitForgotForm);
		loginForm.on("submit", submitLoginForm);
	}

	function showForgotForm() {
		$('#forgot-form').removeClass('login-register__form_hide');
		$('#login-form').addClass('login-register__form_hide');
		$('.login-tab-navigation').hide();
	}

	function showLoginForm() {
		$('#forgot-form').addClass('login-register__form_hide');
		$('#login-form').removeClass('login-register__form_hide');
		$('.login-tab-navigation').show();
	}

	function submitForgotForm(e) {
		let $form = $(e.currentTarget);
		let $messages = $form.find('.form-message');

		e.preventDefault();

		$messages.removeClass('form-message_show');
		form.validateForm($form);

		if (!$form.hasClass('has-error')) {
			$form.addClass('has-processing has-processing_active');
			let data = $form.serializeArray();
			$.ajax({
				url: '/action/pmiForgetPassword',
				type: 'POST',
				data,
				cache: false,
				complete: ({ responseText }) => {
					$form.removeClass('has-processing has-processing_active');
					if (responseText.indexOf("success") > -1) {
						$('.form-message_success').addClass('form-message_show');
					}
				}
			});
		}
	}

	function submitLoginForm(e) {
		let $form = $(e.currentTarget);
		let $messages = $form.find('.form-message');
		
		e.preventDefault();

		$messages.removeClass('form-message_show');
		form.validateForm($form);

		if (!$form.hasClass('has-error')) {
			$form.addClass('has-processing has-processing_active');
			let data = $form.serializeArray();
			data.push({
				name: "ajax",
				value: true
			});
			$.ajax({
				url: '/action/login',
				type: 'POST',
				data,
				cache: false,
				complete: ({ responseText }) => {
					if (responseText.indexOf("success") > -1) {
						if (responseText.split("success-")[1].length !== -1) {
							window.location = responseText.split("success-")[1];
						} else {
							window.location = $('[name="forward"]', $form).val();
						}
					} else {
						$('.form-message_invalid').addClass('form-message_show');
						$form.removeClass('has-processing has-processing_active');
					}
				}
			});
		}
	}

	function goToNews({currentTarget, target}) {
		if (target.tagName.toLowerCase() !== 'a') {
			window.location = currentTarget.dataset.url;
		}
	}

	$(init);
	
})(jQuery);